import { render, staticRenderFns } from "./urgence.vue?vue&type=template&id=3946b4cf&"
import script from "./urgence.vue?vue&type=script&lang=js&"
export * from "./urgence.vue?vue&type=script&lang=js&"
import style0 from "./urgence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports